import React from 'react';
import ControlsClose from './ControlsClose';
const ControlsCloseS = ({ color, ...props }) => (React.createElement(ControlsClose, Object.assign({ color: color, size: 24 }, props)));
ControlsCloseS.displayName = 'ControlsCloseS'; // Fix for tsc
export default ControlsCloseS;
//# sourceMappingURL=ControlsCloseS.js.map